<template>
  <table class='table table-bordered'>
    <tr>
      <th>Days</th>
      <th>Min</th>
      <th>Max</th>
      <th>Avg</th>
    </tr>
    <tr v-for='dailyData in data.slice().reverse()' :key="dailyData.hari">
      <th >{{ dailyData.hari }}</th>
      <template>
          <td>{{dailyData.minimumstring}}</td>
          <td>{{dailyData.maximumstring}}</td>
          <td>{{dailyData.averagestring}}</td>
      </template>
    </tr>
  </table>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style scoped>
  th, td{
    text-align: center;
  }
</style>
